import {TYPES} from './notificationConstants'

export default class NotificationEngine {
  constructor () {
    this.currentNotification = null
  }

  get (not) {
    this.currentNotification = not
    switch (not.notification_type) {
      case TYPES.ASSIGNED_OPEN_AP:
        return {
          title: 'Import Open AP Target',
          action: this.openAPFunction
        }
      case TYPES.USER:
        return {
          title: 'Select Market Demo',
          action: this.marketDemoFunction
        }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/appLogic/notifications/NotificationEngine.js